import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Card, CardContent, CardHeader } from '../../ui/card';

const CardLoadingSkeleton = ({ 
  lines = 3,
  showHeader = true,
  showIcon = false,
  showFooter = false,
  className = ""
}) => {
  return (
    <Card className={`bg-slate-50 border-slate-200 ${className}`}>
      {showHeader && (
        <CardHeader>
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-32" />
            {showIcon && <Skeleton className="h-8 w-8 rounded-lg" />}
          </div>
        </CardHeader>
      )}
      
      <CardContent className="space-y-2">
        {/* Main content lines */}
        {[...Array(lines)].map((_, index) => (
          <Skeleton 
            key={index} 
            className={`h-4 ${
              index === 0 ? 'w-full' : 
              index === 1 ? 'w-3/4' : 
              'w-1/2'
            }`} 
          />
        ))}
        
        {/* Large number or metric */}
        <div className="pt-2">
          <Skeleton className="h-8 w-24" />
        </div>
      </CardContent>
      
      {showFooter && (
        <div className="px-6 pb-4">
          <div className="flex items-center justify-between pt-4 border-t">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-6 w-16" />
          </div>
        </div>
      )}
    </Card>
  );
};

export default CardLoadingSkeleton;